import { memo } from 'react';

import { cn } from '@/lib/utils';

interface CharacterCounterProps {
  currentLength: number;
  maxLength: number;
  label: string;
  error?: boolean;
}

/**
 * Memoized character counter to prevent unnecessary rerenders
 */
export const CharacterCounter = memo(
  ({ currentLength, maxLength, label, error }: CharacterCounterProps) => (
    <div className="mb-2 flex items-center justify-between">
      <p className={cn('text-s text-foreground', error && 'text-warning')}>{label}</p>
      <span className="text-xs text-foreground-muted">
        {currentLength}/{maxLength}
      </span>
    </div>
  )
);
CharacterCounter.displayName = 'CharacterCounter';
